/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type FC } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';
import { jsx } from '@atlaskit/css';

import { type SearchResult } from './ContentTreeSearchBase.tsx';
import { ContentSearchResultItem } from './ContentSearchResultItem.tsx';

type ContentSearchResultListProps = {
	pagesList: SearchResult[];
	onItemClick?: (id: string, index?: number) => void;
	spaceKey?: string;
	contentId?: string;
};

export const ContentSearchResultList: FC<ContentSearchResultListProps> = ({
	pagesList,
	onItemClick,
	contentId,
}) => {
	return (
		<Stack testId="content-search-result-list" role="list">
			{pagesList.map(
				(
					{ title, id, hasRestrictions, hasInheritedRestrictions, displayEmoji, type, subType },
					index,
				) => {
					const isCurrentPage = Boolean(contentId && contentId === id);
					let parsedId = id;
					// databases and embeds currently have their id returned as 'activation/ACTIVATION_ID/ENTITY_ID', so we are parsing the entity id
					if ((type === 'database' || type === 'embed') && id) {
						parsedId = id.split('/').pop() || null;
					}

					const item = {
						id: parsedId || '',
						hasRestrictions,
						hasInheritedRestrictions,
						data: {
							type,
							subType,
						},
					};

					return (
						<ContentSearchResultItem
							key={id}
							index={index}
							title={title || ''}
							item={item}
							onItemClick={onItemClick}
							isCurrentPage={isCurrentPage}
							displayEmoji={displayEmoji}
						/>
					);
				},
			)}
		</Stack>
	);
};
